dealCardsTemplate = require '../deal_cards.html.mustache'
CardUI = require 'grpn-card-ui/frontend/init'

recommendedForYouSelector = 'section.recommended-for-you'

removeRecommendedForYou = ->
  $(recommendedForYouSelector).remove()

fetchMegamindAndRender = (cb) ->
  merchantSlug = window.location.pathname.match(/\/biz\/(.+)/)?[1]
  return removeRecommendedForYou() unless merchantSlug?

  place = $('.mpp-container').data()
  data =
    lat: place.placeLat
    lon: place.placeLon
    division: place.placeDivision

  request = $.get "/merchant-page/megamind/#{merchantSlug}", data, (res) ->
    if res?.data?.cardatronCards 
      $recommendedForYouDealsList = $ "#{recommendedForYouSelector} .twelve.columns"
      $recommendedForYouDealsList.addClass 'cui-four-up'
      $recommendedForYouDealsList.html res.data.cardatronCards
      CardUI.init($recommendedForYouDealsList)
      return
    templateData = res?.data?.megamindWidgets?.bottomSlot
    return removeRecommendedForYou() if not templateData?

    templateData.translate = templateData.t = -> (text) -> I18n.translate text
    recommendedForYouHtml = dealCardsTemplate.render templateData

    $recommendedForYouDealsList = $ "#{recommendedForYouSelector} .deal-cards"
    $recommendedForYouDealsList.html recommendedForYouHtml
    $recommendedForYouDealsList.removeClass 'loading gig-spinner gig-spinner-brnd'

    # update the "View All" link
    $("#{recommendedForYouSelector} a.title").attr('href', templateData.viewAllUrl) if templateData.viewAllUrl?

    cb()

  request.fail ->
    removeRecommendedForYou()

$ ->
  return unless $(recommendedForYouSelector).length
  fetchMegamindAndRender ->
    GIG.Utils.truncateElements recommendedForYouSelector
